var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.072 0h31.847v45H14.063l.009-45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.847 0h15.92v45h-15.92V0ZM45.92 0h15.919v45h-15.91l-.01-45ZM18.844 21.75l-1.247.413 5.756 5.062c.44 1.284-.15 1.669-.525 2.344l6.244-.788-.15 6.282 1.303-.029-.29-6.243 6.253.75c-.385-.816-.732-1.247-.375-2.55l5.747-4.782-1.004-.375c-.825-.637.357-3.056.525-4.584 0 0-3.346 1.153-3.562.544l-.863-1.64-3.056 3.355c-.328.085-.469-.047-.553-.328l1.406-7.012-2.23 1.256c-.188.084-.376.01-.488-.206l-2.157-4.313-2.212 4.481c-.169.16-.338.179-.469.066l-2.147-1.19 1.285 6.946c-.104.282-.347.357-.629.207l-2.925-3.31c-.375.61-.637 1.603-1.143 1.828-.507.216-2.203-.422-3.338-.656.394 1.388 1.594 3.713.844 4.472Z",
    fill: "#D52B1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanFlag);
export default __webpack_public_path__ + "static/media/can-flag.7d00f58cc90c906adbd511aab2b998e3.svg";
export { ForwardRef as ReactComponent };